module.exports = __webpack_public_path__ + "img/CZ.e8cd3eb2.jpg";